"use client";
import { Box, Card, CardActionArea, Stack, Typography } from "@mui/material";
import CarouselHeader from "@/app/(main)/_components/MainPage/CarouselHeader";
import { PropsWithChildren, ReactNode, useEffect, useRef, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import NextLink from "next/link";
import CarouselFooter from "./CarouselFooter";
import { SProduct } from "@/__generated__/sdk";
import Image from "next/image";
import ProductCard from "@/app/(main)/_components/SITESEARCH/ProductCard";

type Props = {
  title: string;
  icon?: ReactNode;
  href?: string;
  items?: SProduct[];
  xlCount?: number;
  lgCount?: number;
  mdCount?: number;
};
export default function CardCarousel({ title, icon, href, items, xlCount, lgCount,mdCount }: Props) {
  const xlNum = xlCount || 5;
  const lgNum = lgCount || 5;
  const mdNum = mdCount || 3;

  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: false, direction: "rtl", dragFree: true, align: "start" });
  useEffect(() => {
    if (emblaApi) {
      // Embla API is ready
    }
  }, [emblaApi]);

  const slideSpacingXs = "1rem";
  const slideSizeXs = "calc(100% / 2)";
  const slideSpacingSm = "1rem";
  const slideSizeSm = "calc(100% / 3)";
  const slideSpacingMd = "1rem";
  const slideSizeMd = `calc(100% / ${mdNum})`;
  const slideSpacingLg = "1rem";
  const slideSizeLg = `calc(100% / ${lgNum})`;
  const slideSpacingXl = "1rem";
  const slideSizeXl = `calc(100% / ${xlNum})`;
  const NotFountCard = () => {
    return (
      <Card
        elevation={0}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: 2,
          gap: 1,
          minWidth: 0,
          width: "100%",
          userSelect: "none",
          background: "transparent",
          // flex: {
          //   xs: `0 0 ${slideSize}`,
          // },
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: { xs: 250, md: 320 },
            aspectRatio: 1,
          }}
        >
          <Image src={"/errors/sadBasket.svg"} fill alt={"sadBasket"} style={{ objectFit: "contain" }} />
        </Box>
        <Typography variant="body2">محصولی پیدا نشد</Typography>
      </Card>
    );
  };
  const CardBox = ({ children }: PropsWithChildren) => {
    return (
      <Box
        sx={{
          minWidth: 0,
          flex: {
            xs: `0 0 ${slideSizeXs}`,
            sm: `0 0 ${slideSizeSm}`,
            md: `0 0 ${slideSizeMd}`,
            lg: `0 0 ${slideSizeLg}`,
            xl: `0 0 ${slideSizeXl}`,
          },
          pr: {
            xs: `${slideSpacingXs}`,
            sm: `${slideSpacingSm}`,
            md: `${slideSpacingMd}`,
            lg: `${slideSpacingLg}`,
            xl: `${slideSpacingXl}`,
          },
        }}
      >
        {children}
      </Box>
    );
  };
  return (
    <>
      <Stack mt={5} spacing={2}>
        <CarouselHeader title={title} icon={icon} href={href} emblaApi={emblaApi} />
        {/* embla */}
        <Box width={"100%"} sx={{ position: "relative" }}>
          {/*  embla__viewport */}
          <Box sx={{ overflow: "hidden", position: "relative" }} ref={emblaRef}>
            {/* embla__container */}
            <Box
              sx={{
                backfaceVisibility: "hidden",
                display: "flex",
                touchAction: "pan-y pinch-zoom",
                py: 0.2,
                mr: {
                  xs: `calc(${slideSpacingXs} * -1)`,
                  sm: `calc(${slideSpacingSm} * -1)`,
                  md: `calc(${slideSpacingMd} * -1)`,
                  lg: `calc(${slideSpacingLg} * -1)`,
                  xl: `calc(${slideSpacingXl} * -1)`,
                },
              }}
            >
              {(!items || items.length <= 0) && <NotFountCard />}
              {items &&
                items.length > 0 &&
                items.map((slide, index) => {
                  return (
                    // embla__slide
                    <CardBox key={index}>
                      <ProductCard product={slide} />
                    </CardBox>
                  );
                })}
            </Box>
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 0.5, py: 1.7 }}>
            <CarouselFooter emblaApi={emblaApi} />
          </Box>
        </Box>
      </Stack>
    </>
  );
}
